/**
 * Hardcoded mock data for verifying UI display before the real API (TAV-2025) is available.
 * TODO: TAV-2033 — Remove this file and restore real API calls in sessions.ts once TAV-2025 is deployed.
 */
import { RoreSession, SessionStatus } from '~rore/types';

export const MOCK_PROCESSING_SESSION: RoreSession = {
  session_id: 'mock-session-processing',
  status: SessionStatus.Processing,
  created_at: '2026-04-01T08:00:00Z',
  started_at: '2026-04-01T08:00:00Z',
};

export const MOCK_COMPLETED_SESSION: RoreSession = {
  session_id: 'mock-session-completed',
  status: SessionStatus.Completed,
  created_at: '2026-04-01T08:00:00Z',
  completed_at: '2026-04-01T08:03:45Z',
  recommendations: [
    {
      shift_id: 1001,
      staff: [
        {
          staff_id: 201,
          score: 0.92,
          factors: { skill: 0.85, availability: 0.95, proximity: 0.88 },
          travel_time_minutes: 12,
          name: 'Sarah Johnson',
          photo_path_1: null,
          qualifications: ['Cert III Individual Support', 'First Aid'],
        },
        {
          staff_id: 202,
          score: 0.87,
          factors: { skill: 0.90, availability: 0.80, proximity: 0.82 },
          travel_time_minutes: 18,
          name: 'Michael Chen',
          photo_path_1: null,
          qualifications: ['Cert IV Disability', 'Manual Handling'],
        },
        {
          staff_id: 203,
          score: 0.74,
          factors: { skill: 0.70, availability: 0.85, proximity: 0.60 },
          travel_time_minutes: 25,
          name: 'Emma Williams',
          photo_path_1: null,
          qualifications: ['Cert III Individual Support'],
        },
      ],
    },
    {
      shift_id: 1002,
      staff: [
        {
          staff_id: 204,
          score: 0.95,
          factors: { skill: 0.92, availability: 1.0, proximity: 0.90 },
          travel_time_minutes: 8,
          name: 'David Park',
          photo_path_1: null,
          qualifications: ['Cert IV Disability', 'First Aid', 'Medication Administration'],
        },
        {
          staff_id: 201,
          score: 0.81,
          factors: { skill: 0.85, availability: 0.75, proximity: 0.78 },
          travel_time_minutes: 15,
          name: 'Sarah Johnson',
          photo_path_1: null,
          qualifications: ['Cert III Individual Support', 'First Aid'],
        },
      ],
    },
    {
      shift_id: 1003,
      staff: [
        {
          staff_id: 205,
          score: 0.88,
          factors: { skill: 0.80, availability: 0.90, proximity: 0.92 },
          travel_time_minutes: 5,
          name: null,
          photo_path_1: null,
          qualifications: null,
        },
      ],
    },
  ],
  metrics: {
    shifts_processed: 3,
    recommendations_generated: 6,
    processing_time_ms: 2450,
  },
};

export const MOCK_FAILED_SESSION: RoreSession = {
  session_id: 'mock-session-failed',
  status: SessionStatus.Failed,
  created_at: '2026-04-01T08:00:00Z',
  error: {
    code: 'TIMEOUT',
    message: 'Solver exceeded maximum processing time of 300 seconds',
  },
};

/**
 * Returns mock session data based on the session ID.
 * - IDs containing "processing" → processing state
 * - IDs containing "failed" → failed state
 * - ID "not-found" → null (triggers 404)
 * - Any other ID → completed state with recommendations
 */
export const getMockSession = (sessionId: string): RoreSession | null => {
  if (sessionId === 'not-found') return null;
  if (sessionId.includes('processing')) return { ...MOCK_PROCESSING_SESSION, session_id: sessionId };
  if (sessionId.includes('failed')) return { ...MOCK_FAILED_SESSION, session_id: sessionId };
  return { ...MOCK_COMPLETED_SESSION, session_id: sessionId };
};
